import { useStore } from '@proscom/prostore-react';
import { STORE_AUTH } from './names';

export function useCurrentUser() {
  const [auth] = useStore(STORE_AUTH);
  return auth?.authData?.user;
}
